import { Link } from '@remix-run/react';

export function NewFooter() {
  return (
    <footer className="border-t border-gray-200 py-12 dark:border-gray-800 dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center justify-between md:flex-row">
          <div className="mb-8 md:mb-0">
            <p className="text-sm dark:text-gray-400">&copy; {new Date().getFullYear()}, AI Dragon</p>
          </div>
          <div className="mb-8 flex flex-wrap justify-center gap-8 md:mb-0">
            <Link className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white" to="/platform-service-terms">
              Platform Service Terms
            </Link>
            <Link className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white" to="/privacy-policy">
              Privacy Policy
            </Link>
            <Link className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white" to="/cookie-policy">
              Cookie Policy
            </Link>
            <Link
              className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white"
              to="/docs/about-us/contact-us"
            >
              Contact Us
            </Link>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            {/* <Link className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white" to="#">
              Social
            </Link>
            <Link className="hover:text-gray-600 dark:text-gray-400 dark:hover:text-white" to="#">
              Links
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
}
